import { render, staticRenderFns } from "./sat.vue?vue&type=template&id=33c60628"
import script from "./sat.vue?vue&type=script&lang=js"
export * from "./sat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports